import React from 'react';
import Maintenance from './Maintenance'; // 引入我们刚刚创建的维护组件
import MainSite from './homecomponents/Mainsite'


function Home() {
    // 网站当前处于维护模式
    const isMaintenanceMode = false;

    // 当维护结束后，您可以将 isMaintenanceMode 设置为 false
    // 并在这里渲染您真正的网站主页组件
    // 例如: return isMaintenanceMode ? <Maintenance /> : <RealHomePage />;

    return isMaintenanceMode ? <Maintenance /> : <MainSite />;
}

export default Home;
